import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import CustomLink from '@gerenciatd/next.components.custom-link';
import SwipableArea from '@/components/swipable-area';

const isEqual = require('react-fast-compare');

/**
 * Stateless component to draw a claim
 * @param {array} slides array with info on a components structure like banner
 * @param {string} className className to help developer for styling
 * @param {bool} autoplay bool prop for autoplaying
 * @returns {JSX} Component JSX.
 */

class Carousel3D extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideTotal: 0,
      slideCurrent: -1,
      slides: [],
      height: '0px',
      minHeight: props.minHeight || 0,
      autoplay: false,
    };
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props.minHeight > state.minHeight) {
      return {
        ...state,
        minHeight: props.minHeight,
      };
    }
    return { ...state };
  };

  componentDidMount = () => {
    let slides = [];
    this.props.slides.forEach((slide) => {
      let slideobject = {
        class: 'slider-single proactivede',
        element: slide,
      };
      slides.push(slideobject);
    });
    this.setState((prevState, props) => {
      return {
        slides,
        slideTotal: this.props.slides.length - 1,
      };
    });

    if (this.state.slideCurrent === -1) {
      setTimeout(() => {
        this.slideRight();
      }, 500);
    }

    const { autoplay } = this.props;

    if (autoplay && autoplay > -1) {
      this.interval = setInterval(() => {
        this.slideRight();
      }, autoplay * 1000);
    }
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (prevProps.slides && prevProps.slides[0] && this.props.slides[0]) {
      if (!isEqual(prevProps.slides[0], this.props.slides[0])) {
        const slides = [];
        this.props.slides.forEach((slide) => {
          const slideobject = {
            class: 'slider-single proactivede',
            element: slide,
          };
          slides.push(slideobject);
        });
        this.setState(() => {
          return {
            slides,
            slideTotal: this.props.slides.length - 1,
            slideCurrent: -1,
          };
        });
        this.setState((myPrevState) => {
          return { ...myPrevState };
        });
        setTimeout(() => {
          this.slideRight();
        }, 500);
      }
    }
  };

  resetAllClassName = (slide) => {
    return slide.map((currentSlide) => {
      const newCurretSlide = {
        ...currentSlide,
      };
      newCurretSlide.class = '';
      return newCurretSlide;
    });
  };

  setSlidesClassName = (slide, slideCurrent, newNumber, number) => {
    slide.forEach((slid, index) => {
      const currentClassName = slid.class;
      /* STATUS MIDDLE */
      if (!currentClassName) {
        let class2Assign = '';
        // deciding if pro or pre
        if (index < slideCurrent) {
          class2Assign = 'slider-single preactivede';
        } else {
          class2Assign = 'slider-single proactivede';
        }
        slide = this.setClass2Slider(slide, index, class2Assign);
      }
    });
    this.setState(
      {
        slides: slide,
        slideCurrent,
      },
      () => {
        if (newNumber !== number) {
          this.goToSlide(number);
        }
      },
    );
  };

  setClass2Slider = (slide, index, className) => {
    const newSlide = [...slide];
    newSlide[index].class = className;
    return newSlide;
  };

  // para este momento slideCurrent siempre será > 0
  goToSlide = (number) => {
    clearInterval(this.interval);
    const { slideTotal } = this.state;
    let { slideCurrent } = this.state;
    let newNumber = number;
    let way = '';
    if (typeof number === 'number') {
      // a laq ue quiero ir: number
      // en la que estoy: slideCurrent
      // el total: slideTotal
      // voy a la derecha:
      if (
        number - slideCurrent < 0 ||
        (number === slideTotal && slideCurrent === 0)
      ) {
        way = 'left';
      } else {
        way = 'right';
      }
    }

    let slide = [...this.state.slides];
    slide = this.resetAllClassName(slide);

    if (way === 'right') {
      slideCurrent = slideCurrent < slideTotal ? (slideCurrent += 1) : 0;
      newNumber = slideCurrent;
      const activeSlideIndex = slideCurrent;
      slide = this.setClass2Slider(
        slide,
        activeSlideIndex,
        'slider-single active',
      );
      const preactiveSlideIndex =
        slideCurrent > 0 ? slideCurrent - 1 : slideTotal;
      slide = this.setClass2Slider(
        slide,
        preactiveSlideIndex,
        'slider-single preactive',
      );
      const proActiveSlideIndex =
        slideCurrent < slideTotal ? slideCurrent + 1 : 0;
      slide = this.setClass2Slider(
        slide,
        proActiveSlideIndex,
        'slider-single proactive',
      );
      this.setSlidesClassName(slide, slideCurrent, newNumber, number, way);
    }

    if (way === 'left') {
      slideCurrent = slideCurrent > 0 ? (slideCurrent -= 1) : slideTotal;
      newNumber = slideCurrent;
      const activeSlideIndex = slideCurrent;
      slide = this.setClass2Slider(
        slide,
        activeSlideIndex,
        'slider-single active',
      );
      const preactiveSlideIndex =
        slideCurrent > 0 ? slideCurrent - 1 : slideTotal;
      slide = this.setClass2Slider(
        slide,
        preactiveSlideIndex,
        'slider-single preactive',
      );
      const proActiveSlideIndex =
        slideCurrent < slideTotal ? slideCurrent + 1 : 0;
      slide = this.setClass2Slider(
        slide,
        proActiveSlideIndex,
        'slider-single proactive',
      );
      this.setSlidesClassName(slide, slideCurrent, newNumber, number, way);
    }
  };

  slideRight = () => {
    const { slideTotal } = this.state;
    let { slideCurrent } = this.state;
    let preactiveSlide = null;
    let proactiveSlide = null;
    if (slideCurrent < slideTotal) {
      slideCurrent += 1;
    } else {
      slideCurrent = 0;
    }

    const slide = this.state.slides;

    if (slideCurrent > 0) {
      preactiveSlide = slide[slideCurrent - 1];
    } else {
      preactiveSlide = slide[slideTotal];
    }

    const activeSlide = slide[slideCurrent];
    if (slideCurrent < slideTotal) {
      proactiveSlide = slide[slideCurrent + 1];
    } else {
      proactiveSlide = slide[0];
    }

    slide.forEach((slid) => {
      if (slid.class.includes('preactivede')) {
        slid.class = 'slider-single proactivede';
      }
      if (slid.class.includes('preactive')) {
        slid.class = 'slider-single preactivede';
      }
    });

    preactiveSlide.class = 'slider-single preactive';
    activeSlide.class = 'slider-single active';
    proactiveSlide.class = 'slider-single proactive';

    this.setState({
      slides: slide,
      slideCurrent,
    });
  };

  renderDots = (slides, slideCurrent) => {
    const key = this.props.className ? '3dCarousel' : '';
    const { taggingInfo } = this.props;
    return (
      <div className="dots-gap">
        <div className="dots">
          {slides.map((slide, index) => {
            const svgCss =
              index === slideCurrent
                ? ' single-dot--active'
                : ' single-dot--unactive';
            const customTaggingInfo = {
              ...taggingInfo,
              componentContent: `Bolita-ir-slide-${index}`,
              debug: true,
            };
            return (
              <div
                key={`${key}-${index.toString()}`}
                className={`single-dot${svgCss}`}
              >
                <CustomLink
                  taggingInfo={customTaggingInfo}
                  isBlockElement
                  onClick={() => {
                    this.goToSlide(index);
                  }}
                />
              </div>
            );
          })}
        </div>
        <style jsx>
          {`
            .dots-gap{
              height: 4rem;
              .dots{
                position: absolute;
                width: 100%;
                text-align: center;
                margin-top: 30px;
                margin-bottom: 30px;
                .single-dot{
                  position: relative;
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  border: 1px solid #fff;
                  border-radius: 10px;
                  transition: all .3s;
                    &--unactive{
                    width: 12px;
                    height: 12px;
                    margin: 2.5px;
                  }
                  &--active{
                      width: 20px;
                      height: 12px;
                      background-color: #fff;
                      margin: 2.5px;
                  }
                }
              }
            }
          `}
          </style>
      </div>
    );
  };

  buildTaggingInfo = (
    index,
    taggingInfo,
    eventType = 'click',
    way = 'left',
  ) => {
    return {
      ...taggingInfo,
      eventType,
      componentContent:
        way === 'left' ? `Ir-Atras-${index}` : `Ir-Adelante-${index}`,
      debug: true,
    };
  };

  renderSlides = (slides) => {

    return (
      <div id="swipable-carousel3d">
        <div className="slider-container">
          <div className="slider-content">
            {slides.map((slider, index) => {
              return (
                <div
                  key={`3d-slide-${index.toString()}`}
                  className={slider.class}
                >
                  <div className="slider-single-content">{slider.element}</div>
                </div>
              );
            })}
          </div>
        </div>
        <style jsx>
          {
            `
            #swipable-carousel3d{
              position: relative;
              height: 100%;
              width: 100%;    
              max-width: 1224px;          
              
              .slider-container {
                position: absolute;
                left: 50%;
                top: 0%;
                // bottom:-50%;
                width: 100%;
                // height: 50vw;
                margin: -0px auto 0px -45%;
                .slider-content {
                  position: relative;
                  left: 50%;
                  top: 0%;
                  width: 90%;
                  min-width: 320px;
                  height: 100%;
                  transform: translateX(-56%);
                  .slider-single {
                    position: absolute;
                    z-index: 0;
                    left: 0;
                    top: 0;
                    width: 100%;
                    // height: 100%;
                    transition: z-index 0ms 200ms;
                    .slider-single-content {
                      position: relative;
                      left: 0;
                      top: 0;
                      width: 100%;
                      min-height: 20rem;
                    //   height: 100%;
                      box-shadow: 0px 10px 40px rgba(0, 0, 0, .2);
                      transition: 500ms cubic-bezier(.17, .67, .55, 1.43);;
                      transform: scale(0);
                      opacity: 0;
                      img{
                        max-width: 100%;
                      }
                    }
                    &.preactivede {
                      //z-index: 0;
                      .slider-single-content {
                        //opacity: 0;
                        transform: translateX(-50%) scale(0);
                      }
                    }
                    &.preactive {
                      z-index: 1;
                      .slider-single-content {
                        opacity: .3;
                        transform: translateX(-25%) scale(.8);
                      }
                    }
                    &.proactive {
                      z-index: 1;
                      .slider-single-content {
                        opacity: .3;
                        transform: translateX(25%) scale(.8);
                      }
              
                    }
                    &.proactivede {
                      //z-index: 0;
                      .slider-single-content {
                        //opacity: 0;
                        transform: translateX(50%) scale(0);
                      }
                    }
                    &.active {
                        .slider-left,.slider-right{
                            display: block;
                        }
                        
                      z-index: 2;
                      .slider-single-content {
                        opacity: 1;
                        transform: translateX(0%) scale(1);
                      }
                      
                    }
                  }
                }
                .slider-left {
                  position: absolute;
                  display: none;
                  z-index: 3;
                  right: 101%;
                  margin-right: 5px;
                  padding: 20px 15px;
                  height: 100%;
                  cursor: pointer;
                  div{
                    position: absolute;
                    top: 50%;
                    left: 0%;
                    margin-top:-20px;
                    color: #ffffff;
                    transform: translateY(-50%);
                    padding: 10px 10px;
                    border-top: 2px solid #fdc84b;
                    border-right: 2px solid #fdc84b;
                    border-bottom: 2px solid #fdc84b;
                    border-left: 2px solid #fdc84b;
                  }
                }
                .slider-right {
                  display: none;
                  position: absolute;
                  z-index: 3;
                  left: 101%;
                  padding: 20px 15px;
                  height: 101%;
                  cursor: pointer;
                  div {
                    position: absolute;
                    top: 50%;
                    left: 0%;
                    margin-top:-20px;
                    color: #ffffff;
                    transform: translateY(-50%);
                    padding: 10px 10px;
                    border-top: 2px solid #fdc84b;
                    border-right: 2px solid #fdc84b;
                    border-bottom: 2px solid #fdc84b;
                    border-left: 2px solid #fdc84b;
                  }
                  margin-left: -2px;
                }
              }
            }
            
            `
          }
        </style>
      </div>
    );
  };

  handleSwipe = (way = 'right', index) => {
    const { taggingInfo } = this.props;
    const newTaggingInfo = this.buildTaggingInfo(
      index,
      taggingInfo,
      'swipe',
      way,
    );
    const metricsImport = import('@gerenciatd/next.utils.metrics');
    metricsImport.then((metrics) => {
      const { sendCMSEvent } = metrics;
      sendCMSEvent(newTaggingInfo);
    })
    this.goToSlide(index);
  };

  render() {
    const { className, swipe, minimunSpace, taggingInfo } = this.props;
    const classNameCss = className ? `${className} ` : '';
    const { slides, slideCurrent, minHeight } = this.state;
    const totalSlides = slides.length;
    const nextSlide = slideCurrent < totalSlides - 1 ? slideCurrent + 1 : 0;
    const backSlide = slideCurrent > 0 ? slideCurrent - 1 : totalSlides - 1;


    const prevTaggingInfo = this.buildTaggingInfo(
      backSlide,
      taggingInfo,
      'click',
      'left',
    );
    const nextTaggingInfo = this.buildTaggingInfo(
      nextSlide,
      taggingInfo,
      'click',
      'right',
    );

    return (
      <>
        <div
          className={`${classNameCss} react-3d-carousel`}
          style={{ minHeight: `${minHeight}px` }}
        >
          {slides && totalSlides > 0 && swipe && (
            <SwipableArea
              id="swipable-carousel3d"
              onSwipeRight={() => {
                this.handleSwipe('right', nextSlide);
              }}
              onSwipeLeft={() => {
                this.handleSwipe('left', backSlide);
              }}
              minimunSpace={minimunSpace}
            >
              {this.renderSlides(slides, nextSlide, backSlide)}
            </SwipableArea>
          )}
          {slides &&
            totalSlides > 0 &&
            !swipe &&
            this.renderSlides(slides, nextSlide, backSlide)}
                      <CustomLink
            onClick={() => {
              this.goToSlide(nextSlide);
            }}
            taggingInfo={nextTaggingInfo}
          >
            <div className="slider_arrow slider_arrow--next" />
          </CustomLink>
          <CustomLink
            onClick={() => {
              this.goToSlide(backSlide);
            }}
            taggingInfo={prevTaggingInfo}
          >
            <div className='slider_arrow slider_arrow--back' />
        </CustomLink>
        </div>
        { this.renderDots(slides, slideCurrent) }
        <style jsx>
          {`
          .react-3d-carousel {
            position:relative;
            max-width: 1224px;
            width:100%;
            margin:0 auto;
            .slider_arrow {
                position: absolute;
                top:50%;
                width: 12rem;
                height: 20rem;
                transform: translate(0%, -50%);
                &.slider_arrow--next { right: -5rem; }
                &.slider_arrow--back{ left: -5rem; }
            }          
          }
          @media screen and (max-width:980px) {
            .react-3d-carousel{
              .slider_arrow { width: 4rem; }
            }
          }
          @media screen and (max-width:530px) {
            .react-3d-carousel{
              .slider_arrow { width: 3rem; }
            }
          }
          @media screen and (max-width:500px) {
            .react-3d-carousel{
              .slider_arrow { width: 2.5rem; }
            }
          }
        `}
        </style>
      </>
    );
  }
}

Carousel3D.propTypes = {
  /**
   * {
   *  "info": "Define los slides del componente",
   *  "kind": "both",
   *  "beautifulName": "Slides"
   * }
   */
  slides: PropTypes.arrayOf(PropTypes.element),
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: PropTypes.string,
  /**
   * {
   *  "info": "Define si hay autoplay, y de haberlo marca el tiempo de cambio de diapositiva. Por defecto -1, ej: 1 --> 1 segundo",
   *  "kind": "both",
   *  "beautifulName": "Autoplay"
   * }
   */
  autoplay: PropTypes.number,
  /**
   * {
   *  "info": "Activa la propiedad swipe del componente",
   *  "kind": "both",
   *  "beautifulName": "Swipe"
   * }
   */
  swipe: PropTypes.bool,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: PropTypes.object,
  /**
   * {
   *  "info": "Define el espacio mínimo para el componente",
   *  "kind": "both",
   *  "beautifulName": "Espacio mínimo "
   * }
   */
  minimunSpace: PropTypes.number,
};
Carousel3D.defaultProps = {
  slides: [],
  className: null,
  autoplay: -1,
  swipe: true,
  taggingInfo: null,
  minimunSpace: 150,
  minHeight: 400,
};

export default Carousel3D;
